import { LicenseDependentButtonModel } from './license-dependent-button.model';

export class PaymentSummaryModel {
  InformationTitle = '';
  InformationText = '';
  LicenseDependentButtonModel = {
    ...new LicenseDependentButtonModel(),
    FullWidth: true
  };
}
